module.exports = __webpack_public_path__ + "static/media/buttonlogo.c8de6eeb.svg";